import { createSlice } from '@reduxjs/toolkit';

import initialState from 'shared/product_tabs/tab_accessories/data/initialState';
import {
  changeQty,
  changeVariant,
  removeFromCart,
  removeAccessoryFromCart,
  selectAccessory,
} from 'shared/product_tabs/tab_accessories/slice/utils';

const accessoriesService = createSlice({
  name: 'accessoriesService',
  initialState,
  reducers: {
    changeAccessoryQuantity: (state, action) => {
      const { quantity, index } = action.payload;
      changeQty(state, index, quantity);
    },
    changeAccessoryVariant: (state, action) => {
      const { variant, index } = action.payload;
      changeVariant(state, index, variant);
    },
    changeAccessorySelected: (state, action) => {
      const { index } = action.payload;
      selectAccessory(state, index);
    },
    removeAll(state) {
      removeFromCart(state);
    },
    removeAccessory: (state, action) => {
      const { product_id } = action.payload;
      removeAccessoryFromCart(state, product_id);
    },
  },
});

export const {
  changeAccessoryQuantity,
  changeAccessorySelected,
  changeAccessoryVariant,
  removeAll,
  removeAccessory,
} = accessoriesService.actions;

export default accessoriesService.reducer;
